import type { BackupStatus } from '@repo/api-gw-sdk';
import React from 'react';

import { ResourceStatusIcon } from '@/components/resourceStatus/resourceStatusBadge';
import { BackupStatuses } from '@/data/inventory/data';

export const BackupStatusIcon = React.forwardRef(
  ({ backupStatus, ...props }: { backupStatus: BackupStatus }, ref) => {
    const data = BackupStatuses[backupStatus];
    if (!data) {
      return null;
    }

    return (
      <ResourceStatusIcon
        ref={ref}
        {...props}
        icon={data.icon}
        iconColor={data.iconColor}
        backgroundColor={data.backgroundColor}
      />
    );
  }
);
